import React from "react";

// Consistent empty-state across the app.
//   <EmptyState icon="📋" title="No tasks yet" description="Create one to get started" action={<Button>New task</Button>} />

export default function EmptyState({ icon, title, description, action, style = {} }) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "48px 24px",
        ...style,
      }}
    >
      {icon && (
        <div style={{ fontSize: 32, marginBottom: 12, opacity: 0.7 }}>{icon}</div>
      )}
      {title && (
        <div style={{ fontSize: 15, fontWeight: 600, color: "var(--text-primary)", marginBottom: 4 }}>
          {title}
        </div>
      )}
      {description && (
        <div style={{ fontSize: 13, color: "var(--text-tertiary)", maxWidth: 320, margin: "0 auto 16px" }}>
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}
